<template>
  <path
    fill="currentColor"
    d="M5.6 15.111 4 6.444l4.8 2.89L12 5l3.2 4.333L20 6.444l-1.6 8.667H5.6ZM6.496 18c-.544 0-.896-.318-.896-.809v-.635h12.8v.635c0 .491-.352.809-.896.809H6.496Z"
  />
</template>
